/* DSA terug-naar-boven-knop */
if (!customElements.get('dsa-scroll-to-top')) {
  class DsaScrollToTop extends HTMLElement {
    connectedCallback() {
      this.showAfter = parseFloat(this.dataset.showAfter) || 400;
      this.button = this.querySelector('button');
      this.ticking = false;
      this.onScroll = () => {
        if (this.ticking) return;
        this.ticking = true;
        requestAnimationFrame(() => {
          this.classList.toggle('is-visible', window.scrollY > this.showAfter);
          this.ticking = false;
        });
      };
      window.addEventListener('scroll', this.onScroll, { passive: true });
      this.onScroll();
      if (this.button) {
        this.button.addEventListener('click', () => {
          const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          window.scrollTo({ top: 0, behavior: reduce ? 'auto' : 'smooth' });
          const main = document.getElementById('MainContent');
          if (main) main.focus({ preventScroll: true });
        });
      }
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScroll);
    }
  }
  customElements.define('dsa-scroll-to-top', DsaScrollToTop);
}
